import { lazy, Suspense, useCallback, useEffect, useMemo, useState } from "react";
import RecentBlog from "./RecentBlog";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import ApiRequest from "../helper/ApiRequest";
import Breadcrumb from "../../component/Breadcrumb";
const OurBlogs = lazy(() => import("./OurBlogs"));

const blogListEndpoint = ApiEndpoints.blogs.blogList;
const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Blogs",
      slug:"/blog"
    }
  ]
}
export default function BlogListing() {
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ApiRequest("GET", blogListEndpoint);
      const result = response.blogs;
      setAllData(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [blogListEndpoint]);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  // Memoize utility functions
  const stripHtmlTags = useMemo(() => {
    return (htmlString) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString;
      return tempDiv.textContent || tempDiv.innerText || "";
    };
  }, []);

  const formatDate = useMemo(() => {
    return (dateString) => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", 
        "September", "October", "November", "December",];
      const month = monthNames[date.getMonth()];
      const day = date.getDate();
      return `${month} ${day}, ${year}`;
    };
  }, []);

  if (loading) {
    return <div style={{width:"100%",height:"100vh"}}>Loading...</div>;
  }

  return (
    <>
      <section className="blog-bread-crumb header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Breadcrumb breadcrumbData={breadcrumbData}/>
            </div>
          </div>
        </div>
      </section>

      <RecentBlog allData={allData} formatDate={formatDate} stripHtmlTags={stripHtmlTags}/>
      <Suspense fallback={null}>
        <OurBlogs allData={allData} formatDate={formatDate} stripHtmlTags={stripHtmlTags}/>
      </Suspense>
    </>
  );
}
